export const TEMPLATE_FILE_PATHS = {
  MANUAL_PRICE_CARD: '/assets/templates/manual-price-card-sample.csv',
  PSID_TEMPLATE_GENERAL_LINK: '/assets/templates/incl_excl.csv',
  PSID_TEMPLATE_UNIQUE_LINK: '/assets/templates/recontactUniqLinkTemp.csv',
};
